import { copilotBands } from './content';
import { IPhoneFrame, MacBook, ProductVisual } from './frames';

const coachOnly = new Set(['voice', 'draft', 'programs']);

function DraftPhone() {
  return (
    <IPhoneFrame>
      <div className="mkt-draft-phone">
        <p className="mkt-draft-kicker">Observation</p>
        <p className="mkt-draft-note">Sasha’s turns off the flags were late on the third 50. The finish was better.</p>
        <p className="mkt-draft-kicker">Parent email</p>
        <p className="mkt-draft-subject">Sasha’s turns</p>
        <p className="mkt-draft-body">
          Sasha’s turns off the flags were late today, and the finish on the last 50 was stronger. We will keep the flags as the focus this week.
        </p>
        <div className="mkt-draft-actions">
          <span>Edit</span>
          <span className="mkt-draft-send">Send</span>
        </div>
      </div>
    </IPhoneFrame>
  );
}

export function CopilotBands({
  level = 'h3',
  coachesOnly = false,
}: {
  level?: 'h2' | 'h3';
  coachesOnly?: boolean;
}) {
  const Title = level;
  const bands = coachesOnly ? copilotBands.filter((band) => coachOnly.has(band.id)) : copilotBands;
  return (
    <div>
      {bands.map((band, index) => (
        <section key={band.id} className="py-10 md:py-14">
          <div
            className={`grid items-center gap-10 lg:gap-16 ${
              index % 2 === 1
                ? 'lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)]'
                : 'lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]'
            }`}
          >
            <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
              <Title className="text-balance text-mkt-section-sm md:text-mkt-section">{band.title}</Title>
              <p className="mt-5 text-mkt-sub-sm text-mkt-secondary md:text-mkt-sub">{band.body}</p>
            </div>
            <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
              {band.id === 'draft' ? (
                <div className="mkt-stage mkt-tone-pool mkt-has-companion">
                  <div className="mkt-layout">
                    <div className="mkt-companion mkt-drift-late">
                      <DraftPhone />
                    </div>
                    <div className="mkt-primary mkt-drift">
                      <MacBook src={band.image} alt={band.alt} avifSrcSet={band.avif} />
                    </div>
                  </div>
                </div>
              ) : (
                <ProductVisual
                  src={band.image}
                  alt={band.alt}
                  device={band.device}
                  tone={band.tone}
                  tilt={band.tilt}
                  companion={band.companion}
                  float={band.float}
                  avifSrc={band.avif}
                />
              )}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
